<template>
  <PageWrap>
    <HeadSeo :data="data?.page" />
    <HeaderOther :h1="data?.page.h1" />
    <main>
      <UiBreadCrumbs
        :data="[
          {
            title: data?.page.title,
          },
        ]"
      />
      <ServiceList :data="data?.service" />
      <BlockWhyWe />
      <BlockArticleText :html="data?.page.text" :name="`page-${data?.page?.id}`" />
      <BlockZakaz />
      <BlockAchievements />
      <BlockContact />
    </main>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { data } = await useFetch("/api/service");
</script>
